import React from 'react';

const ControllerContext = React.createContext();

export default ControllerContext;

export function withRoomControllerContext(Component)
{
	return (props) => ( // eslint-disable-line react/display-name
		<ControllerContext.Consumer>
			{(controller) => <Component {...props} controller={controller} />}
		</ControllerContext.Consumer>
	);
}